import { NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Checkbox } from 'primeng/checkbox';
import { InputText } from 'primeng/inputtext';
import { HelperService } from '../../../../../core/services/helper.service';
import { I18nService } from '../../../../../core/services/i18n.service';
import { PaymentData } from '../../../../interfaces/payment/payment-data';
import { PaymentInvalidFlags } from '../../../../interfaces/payment/payment-invalid-flags';

@Component({
  selector: 'admin-payment-type-email',
  imports: [
    Checkbox,
    FormsModule,
    InputText,
    NgClass
  ],
  templateUrl: './admin-payment-type-email.component.html',
})
export class AdminPaymentTypeEmailComponent {

  i18n = inject(I18nService);
  public helper = inject(HelperService);

  @Input() paymentData: PaymentData;
  @Input() paymentInvalidFlags: PaymentInvalidFlags;

}
